import type {
  DesignActionId,
  ServerProviderSkill,
  ThreadActionSelection,
} from "@afar-research/contracts";

import { resolveAppOwnedSkillInvocation } from "./appOwnedSkillInvocation.ts";
import {
  designSelectionFor,
  resolveThreadAction,
  threadActionAvailability,
  threadActionSkillNames,
  type ThreadActionContext,
} from "./threadActions.ts";

/** Enforce a submitted Design Operation using the same requirements as its Action. */
export function designOperationAvailability(
  operation: DesignActionId,
  context: ThreadActionContext,
) {
  const action = resolveThreadAction(designSelectionFor(operation));
  return threadActionAvailability(action?.type === "built-in" ? action.definition : {}, context);
}

/** Resolve an Action's usable App-owned bundles in invocation order. Callers own custom-skill policy and existing bindings. */
export function resolveActionAppOwnedSkillInvocations(
  skills: ReadonlyArray<ServerProviderSkill>,
  selection: ThreadActionSelection | null | undefined,
) {
  const action = resolveThreadAction(selection);
  if (action === null) return [];
  return threadActionSkillNames(action).flatMap((name) => {
    const invocation = resolveAppOwnedSkillInvocation(skills, name);
    return invocation === null ? [] : [invocation];
  });
}
